var _rect, _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogOutIconRed(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 57,
    viewBox: "0 0 56 57",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.5,
    width: 56,
    height: 56,
    rx: 28,
    fill: "#FFDEE0"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.5 35.0625C31.4141 37.2231 29.6136 39.0577 27.2016 38.9986C26.6404 38.9849 25.9468 38.7893 24.5596 38.398C21.2212 37.4563 18.3231 35.8738 17.6278 32.3285C17.5 31.6768 17.5 30.9435 17.5 29.4768L17.5 27.5232C17.5 26.0565 17.5 25.3232 17.6278 24.6715C18.3231 21.1262 21.2212 19.5437 24.5596 18.602C25.9468 18.2107 26.6404 18.0151 27.2016 18.0014C29.6136 17.9423 31.4141 19.7769 31.5 21.9375",
    stroke: "#DF0C3D",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M25.6666 28.4987H38.5M25.6666 28.4987C25.6666 27.6818 27.9933 26.1555 28.5833 25.582M25.6666 28.4987C25.6666 29.3156 27.9933 30.8419 28.5833 31.4154",
    stroke: "#DF0C3D",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogOutIconRed);
export default __webpack_public_path__ + "static/media/log-out-icon-red.07bf99e9de8d7cf3665e9d0732bfd115.svg";
export { ForwardRef as ReactComponent };